import { render, staticRenderFns } from "./EventModeIndicator.vue?vue&type=template&id=00979a50&scoped=true"
import script from "./EventModeIndicator.vue?vue&type=script&lang=ts&setup=true"
export * from "./EventModeIndicator.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./EventModeIndicator.vue?vue&type=style&index=0&id=00979a50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00979a50",
  null
  
)

export default component.exports